export default __webpack_public_path__ + "static/media/logout-icon.2eb661d2.svg";